import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { ProductTypes } from 'Types/ProductTypes'

export const USAGE_KEYS = {
  currentMonth: 'currentMonth',
  lastMonth: 'lastMonth',
  lastTwoMonths: 'lastTwoMonths',
} as const

export type UsageKeys = keyof typeof USAGE_KEYS

export type Usage = {
  [K in keyof typeof USAGE_KEYS]: number | null
}

export type PackageUsage = {
  limit: number
  overage: number
  product: ProductTypes
  remaining: number
  usePercentage: number
  visitsCount: number
  pace: number
  usage: Usage
}

export type AccountUsage = PackageUsage[]

type QueryFnType = typeof getAccountUsage

const getAccountUsage = (accountId: number) =>
  request<{ data: AccountUsage }>({
    url: `accounts/${accountId}/subscriptions/usage`,
    method: 'GET',
    hideErrorToaster: true,
  })

export const useGetAccountUsage = () => {
  const { accountId, subscriptionId } = useUserStore.getState()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryFn: () => getAccountUsage(accountId),
    queryKey: ['accountUsage', accountId],
    enabled: !!accountId && !!subscriptionId,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data?.data

  return { ...query, data }
}
